import { useMutation } from '@tanstack/react-query';
import type { NotificationCheckRequest } from '../types/Organization';

export default function usePostOrganizationNotificationCheck() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async (params: NotificationCheckRequest) => {
      const response = await fetch('/agent/api/organization_notification/check', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify(params),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || '通知設定の確認に失敗しました');
      }

      return data;
    },
  });
}
